<template>
  <div>
    <b-container fluid="true" ref="container" class="p-0">
      <b-row no-gutters>
        <b-col class="text-center p-0">
          <v-box @resize="sizeChanged">
            <div>
              <img
                  v-if="!checkIsCordova"
                  :src="imageSource"
                  alt="Image"
                  ref="image"
                  :style="'max-width: 100%; max-height:' + imgH +'px; ' +
                 'position: relative; top: 50%; transform: translateY(-50%);'">
              <img
                  v-else
                  :src="$secureUrl(addCordovaUrl + imageSource)"
                  alt="Image"
                  ref="image"
                  :style="'max-width: 100%; max-height:' + imgH +'px; ' +
                 'position: relative; top: 50%; transform: translateY(-50%);'">
            </div>
          </v-box>
        </b-col>
      </b-row>
    </b-container>

    <FooterNavbar data-test-path="slide-show-footer">
      <FooterButton
          v-if="!singleImageEditor"
          type="NavigateLeft"
          @navigate-left="navigateLeft"
          :disabled="arrowLeftDisabled"
      >
      </FooterButton>
      <CloseButton @close="cancel"></CloseButton>
      <FooterButton
          v-if="!imagePreview"
          type="Edit"
          @edit="edit"
          :disabled="isJoined"
      ></FooterButton>
      <DownloadButton
          v-if="!singleImageEditor && checkIsCordova"
          :file-src="$secureUrl(addCordovaUrl + imageSource)">
      </DownloadButton>
      <DownloadButton
          v-if="!singleImageEditor && !checkIsCordova"
          :file-src="imageSource">
      </DownloadButton>
      <FooterButton
          v-if="!singleImageEditor"
          type="NavigateRight"
          @navigate-right="navigateRight"
          :disabled="arrowRightDisabled"
      >
      </FooterButton>
    </FooterNavbar>
  </div>
</template>

<script>

import FooterNavbar from "@/components/navbar/FooterNavbar";
import FileInRepository from "@/server/com/silkplm/model/files/FileInRepository";
import Activity from "@/activity/Activity";
import VBox from "@/components/VBox";
import ActivityManager from "@/activity/ActivityManager";
import FooterButton from "@/components/navbar/FooterButton";
import DownloadButton from "@/components/navbar/DownloadButton";
import CloseButton from "@/components/navbar/CloseButton";

const PinturaImageEditor = () => require("@/components/img/PinturaImageEditor");

export default {
  name: "SlideShow",
  components: {DownloadButton, FooterButton, VBox, FooterNavbar, CloseButton},

  created() {
  },

  computed: {
    checkIsCordova() {
      return window.isCordova
    },
    addCordovaUrl() {
      return window.cordovaUrl
    }
  },
  async mounted() {
    await this.setNavigation();
    await this.setImage(this.image.url);
  },

  methods: {
    ...Activity.methods,

    getTitle() {
      if (this.image) {
        return this.image.data.name;
      } else {
        return $tr("editingImage", "Editing image")
      }
    },

    sizeChanged(height) {
      this.imgH = height;
    },

    setNavigation() {
      this.displayedImageIndex = _.findIndex(this.imagesList, ['token', this.image.token]);
      this.arrowLeftDisabled = this.displayedImageIndex === 0;
      this.arrowRightDisabled = this.displayedImageIndex === this.imagesList.length - 1;
    },
    async edit() {
      let pinturaImageEditorResult = await (await ActivityManager.showActivity(PinturaImageEditor, {
        image: this.image,
        singleImageEditor: this.singleImageEditor,
        uploadImage: this.uploadImage
      })).getResult();

      if (pinturaImageEditorResult) {
        this.image = pinturaImageEditorResult.newFile;
        let replace = pinturaImageEditorResult.replace;
        this.imageSource = this.image.url;
        console.log("should close 2")
        if (replace === true) {
          this.$emit("refactor-image", pinturaImageEditorResult.deletedFile, pinturaImageEditorResult.newFile);
        } else {
          this.$emit("new-image", pinturaImageEditorResult.newFile);
        }
        console.log('should close 3')
      }
    },

    cancel() {
      console.log("Slide show close");
      this.close();
    },

    setImage(src) {
      this.imageSource = src;
    },

    navigateLeft() {
      this.displayedImageIndex -= 1;
      this.image = this.imagesList[this.displayedImageIndex];
      this.imageSource = this.image.url;

      this.displayedImageIndex = _.findIndex(this.imagesList, ['token', this.image.token]);
      if (this.displayedImageIndex === 0) {
        this.arrowLeftDisabled = true;
      }
      this.arrowRightDisabled = false;
    },

    navigateRight() {
      this.displayedImageIndex += 1;
      this.image = this.imagesList[this.displayedImageIndex];
      this.imageSource = this.image.url;

      this.displayedImageIndex = _.findIndex(this.imagesList, ['token', this.image.token]);
      if (this.displayedImageIndex === this.imagesList.length - 1) {
        this.arrowRightDisabled = true;
      }
      this.arrowLeftDisabled = false;
    }
  },


  props: {
    uploadImage: {type: Function, default: null},
    imagesList: {
      type: Array, default() {
        return []
      }
    },
    image: {type: FileInRepository, default: null},
    singleImageEditor: {type: Boolean, default: false},
    imagePreview: {type: Boolean, default: false},
    isJoined: {type: Boolean, default: false},
  },

  data: () => ({
    imgH: 0,
    imageSource: "",
    displayedImageIndex: null,
    arrowLeftDisabled: false,
    arrowRightDisabled: false,
  })
}
</script>

